import PricingComparison from "@/routes/app/settings/billing/components/PricingComparison";
import Pricingv2Component, { PlanType } from "@/routes/app/settings/billing/components/Pricingv2Component";
import { motion } from "framer-motion";
import { useNavigate } from "@remix-run/react";
import { START_ONBOARDING_MAIN } from "@/routes.config";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3
    }
  }
};

export function Pricing() {

  const navigate = useNavigate()

  const handleClick = (plan: PlanType, duration: 'monthly' | 'yearly') => {
    console.log("Clicked plan:", plan, duration);

    navigate(START_ONBOARDING_MAIN(plan, duration))
  };

  return (
    <>
      <motion.section 
        className="py-16 bg-white" 
        id="pricing"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <motion.div 
          className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          <Pricingv2Component currentPlan={null} handleClick={handleClick} />
          <PricingComparison />
        </motion.div>
      </motion.section>

    </>
  );
} 